import React from 'react';

export const IconClose = (
  <svg aria-label="Icon Close" width="1em" height="1em" viewBox="0 0 24 24">
    <defs>
      <path id="a" d="M14.962 12.498l3.695-3.694a1.161 1.161 0 0 0 0-1.643l-.821-.82a1.161 1.161 0 0 0-1.643 0l-3.695 3.694L8.804 6.34a1.161 1.161 0 0 0-1.643 0l-.82.821a1.161 1.161 0 0 0 0 1.643l3.694 3.694-3.695 3.695a1.161 1.161 0 0 0 0 1.643l.821.82a1.161 1.161 0 0 0 1.643 0l3.694-3.694 3.695 3.695a1.161 1.161 0 0 0 1.643 0l.82-.821a1.161 1.161 0 0 0 0-1.643l-3.694-3.695z" />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-.498 -.498)">
      <mask id="b" fill="currentColor">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#000" xlinkHref="#a" />
      <g fill="currentColor" mask="url(#b)">
        <path d="M.498.498h24v24h-24z" />
      </g>
    </g>
  </svg>
);
